import { CommandDomainType } from 'src/enums/command.enum';
import { TCommandConstant } from 'src/types/mixed.type';

export const GAME_LOADED: TCommandConstant = {
  id: -999, // mock
  backendId: 34,
  label: {
    en: 'Game Loaded',
    tr: 'Oyun Yüklendi',
    ar: 'تم تحميل اللعبة',
    es: 'Game Loaded',
    it: 'Game Loaded',
    ro: 'Game Loaded',
  },
  domainId: CommandDomainType.Control,
};

export const SIMULATION_SPEED: TCommandConstant = {
  id: 1,
  backendId: 131,
  label: {
    tr: 'Simülasyon Hızı',
    en: 'Simulation Speed',
    ar: 'سرعة المحاكاة',
    es: 'Simulation Speed',
    it: 'Simulation Speed',
    ro: 'Simulation Speed',
  },
  domainId: CommandDomainType.Control,
};

export const CREATE_AGENT_PROTOTYPE: TCommandConstant = {
  id: 7,
  backendId: 126,
  label: {
    tr: 'Etmen Prototipi Yarat',
    en: 'Create Agent Prototype',
    ar: 'إنشاء نموذج وكيل',
    es: 'Create Agent Prototype',
    it: 'Create Agent Prototype',
    ro: 'Create Agent Prototype',
  },
  domainId: CommandDomainType.Control,
};
export const TPFDD: TCommandConstant = {
  id: 12,
  backendId: 127,
  label: {
    tr: 'E.S.K.Z.(Etmenin Simülasyona Katılacağı Zaman)',
    en: 'T.P.F.D.D.(Time Phased Force and Deployment Data)',
    ar: 'خطة نشر القوات',
    es: 'T.P.F.D.D.(Time Phased Force and Deployment Data)',
    it: 'T.P.F.D.D.(Time Phased Force and Deployment Data)',
    ro: 'T.P.F.D.D.(Time Phased Force and Deployment Data)',
  },
  domainId: CommandDomainType.Control,
};

export const STOP_GAME: TCommandConstant = {
  id: 17,
  backendId: 130,
  label: {
    tr: 'Oyunu Durdur',
    en: 'Stop Game',
    ar: 'إيقاف اللعبة',
    es: 'Stop Game',
    it: 'Stop Game',
    ro: 'Stop Game',
  },
  domainId: CommandDomainType.Control,
};

export const PAUSE_GAME: TCommandConstant = {
  id: 18,
  backendId: 129,
  label: {
    tr: 'Oyunu Duraklat',
    en: 'Pause Game',
    ar: 'إيقاف اللعبة',
    es: 'Pause Game',
    it: 'Pause Game',
    ro: 'Pause Game',
  },
  domainId: CommandDomainType.Control,
};

export const BULK_TELEPORT: TCommandConstant = {
  id: 19,
  backendId: 64,
  label: {
    tr: 'Toplu Teleport',
    en: 'Bulk Teleport',
    ar: 'نقل جماعي',
    es: 'Bulk Teleport',
    it: 'Bulk Teleport',
    ro: 'Bulk Teleport',
  },
  domainId: CommandDomainType.Control,
};

export const CHANGE_SIDE_RELATION_COMMAND: TCommandConstant = {
  id: 3,
  backendId: 136,
  label: {
    tr: 'Taraf İlişki Değiştir',
    en: 'Change Side Relation',
    ar: 'تغيير علاقة الجانب',
    es: 'Change Side Relation',
    it: 'Change Side Relation',
    ro: 'Change Side Relation',
  },
  domainId: CommandDomainType.Control,
};

export const CHANGE_AGENT_CONTROLLER: TCommandConstant = {
  id: 20,
  backendId: 138,
  label: {
    tr: 'Etmen Kontrollcü Değiştir',
    en: 'Change Agent Controller',
    ar: 'تغيير وحدة التحكم في الوكيل',
    es: 'Change Agent Controller',
    it: 'Change Agent Controller',
    ro: 'Change Agent Controller',
  },
  domainId: CommandDomainType.Control,
};

// runtime crud command
export const CHANGE_AGENT_SYMBOL: TCommandConstant = {
  id: 21,
  backendId: 1000,
  label: {
    tr: 'Etmen Sembol Değiştir',
    en: 'Change Agent Symbol',
    ar: 'تغيير رمز الوكيل',
    es: 'Change Agent Symbol',
    it: 'Change Agent Symbol',
    ro: 'Change Agent Symbol',
  },
  domainId: CommandDomainType.Control,
};

export const TOGGLE_SURVIVORS: TCommandConstant = {
  id: 22,
  backendId: 141, //
  label: {
    tr: 'Hayatta kalanlari aç/kapa',
    en: 'Toggle Survivors',
    ar: 'تبديل الناجين',
    es: 'Toggle Survivors',
    it: 'Toggle Survivors',
    ro: 'Toggle Survivors',
  },
  domainId: CommandDomainType.Control,
};

export const MARIN_AND_AIR_POLLUTION: TCommandConstant = {
  id: 23,
  backendId: 89,
  label: {
    tr: 'Kirlilik Yayılımı',
    en: 'Spread Pollution',
    ar: 'إنتشار التلوث',
    es: 'Spread Pollution',
    it: 'Spread Pollution',
    ro: 'Spread Pollution',
  },
  domainId: CommandDomainType.Control,
};

// #region Land Commands
export const DIVIDE: TCommandConstant = {
  id: 101,
  backendId: 11,
  label: {
    tr: 'Böl',
    en: 'Divide',
    ar: 'تقسيم',
    es: 'Divide',
    it: 'Divide',
    ro: 'Divide',
  },
  domainId: CommandDomainType.Land,
};

export const AIR_DEFENSE: TCommandConstant = {
  id: 110,
  backendId: 30,
  label: {
    tr: 'Hava Savunması',
    en: 'Air Defense',
    ar: 'الدفاع الجوي',
    es: 'Air Defense',
    it: 'Air Defense',
    ro: 'Air Defense',
  },
  domainId: CommandDomainType.Land,
};

export const SUPPLY: TCommandConstant = {
  id: 117,
  backendId: 28,
  label: {
    tr: 'İkmal',
    en: 'Supply',
    ar: 'إمداد',
    es: 'Supply',
    it: 'Supply',
    ro: 'Supply',
  },
  domainId: CommandDomainType.Land,
};

export const MERGE: TCommandConstant = {
  id: 123,
  backendId: 12,
  label: {
    tr: 'Birleş',
    en: 'Merge',
    ar: 'دمج',
    es: 'Merge',
    it: 'Merge',
    ro: 'Merge',
  },
  domainId: CommandDomainType.Land,
};

export const LAND_MOVE: TCommandConstant = {
  id: 102,
  backendId: 2,
  label: {
    tr: 'Kara Intikal',
    en: 'Land Move',
    ar: 'تحرك الأرض',
    es: 'Land Move',
    it: 'Land Move',
    ro: 'Land Move',
  },
  domainId: CommandDomainType.Land,
};
export const LAND_BULK_MOVE: TCommandConstant = {
  id: 137,
  backendId: 68,
  label: {
    tr: 'Toplu Kara Intikal',
    en: 'Bulk Land Move',
    ar: 'تحرك جماعي للأرض',
    es: 'Land Move',
    it: 'Land Move',
    ro: 'Land Move',
  },
  domainId: CommandDomainType.Land,
  isBulk: true,
};

export const TELEPORT: TCommandConstant = {
  id: 103,
  backendId: 15,
  label: {
    tr: 'Işınlanma',
    en: 'Teleport',
    ar: 'نقل',
    es: 'Teleport',
    it: 'Teleport',
    ro: 'Teleport',
  },
  domainId: CommandDomainType.Land,
};

export const ATTACK: TCommandConstant = {
  id: 104,
  backendId: 4,
  label: {
    tr: 'Taaruz',
    en: 'Attack',
    ar: 'هجوم',
    es: 'Attack',
    it: 'Attack',
    ro: 'Attack',
  },
  domainId: CommandDomainType.Land,
};
export const BULK_ATTACK: TCommandConstant = {
  id: 136,
  backendId: 70,
  label: {
    tr: 'Toplu Taaruz',
    en: 'Bulk Attack',
    ar: 'هجوم جماعي',
    es: 'Bulk Attack',
    it: 'Bulk Attack',
    ro: 'Bulk Attack',
  },
  domainId: CommandDomainType.Land,
  isBulk: true,
};

export const DEFEND: TCommandConstant = {
  id: 105,
  backendId: 5,
  label: {
    tr: 'Savunma',
    en: 'Defend',
    ar: 'دفاع',
    es: 'Defend',
    it: 'Defend',
    ro: 'Defend',
  },
  domainId: CommandDomainType.Land,
};

export const BULK_DEFEND: TCommandConstant = {
  id: 138,
  backendId: 69,
  label: {
    tr: 'Toplu Savunma',
    en: 'Bulk Defend',
    ar: 'دفاع جماعي',
    es: 'Bulk Defend',
    it: 'Bulk Defend',
    ro: 'Bulk Defend',
  },
  domainId: CommandDomainType.Land,
  isBulk: true,
};

export const WITHDRAW: TCommandConstant = {
  id: 106,
  backendId: 6,
  label: {
    tr: 'Geri Çekilme',
    en: 'Withdraw',
    ar: 'انسحاب',
    es: 'Withdraw',
    it: 'Withdraw',
    ro: 'Withdraw',
  },
  domainId: CommandDomainType.Land,
};

export const BULK_WITHDRAW: TCommandConstant = {
  id: 142,
  backendId: 72,
  label: {
    tr: 'Toplu Geri Çekilme',
    en: 'Bulk Withdraw',
    ar: 'انسحاب جماعي',
    es: 'Bulk Withdraw',
    it: 'Bulk Withdraw',
    ro: 'Bulk Withdraw',
  },
  domainId: CommandDomainType.Land,
  isBulk: true,
};

export const DIRECT_FIRE: TCommandConstant = {
  id: 107,
  backendId: 7,
  label: {
    tr: 'Görerek Ateş',
    en: 'Direct Fire',
    ar: 'إطلاق مباشر',
    es: 'Direct Fire',
    it: 'Direct Fire',
    ro: 'Direct Fire',
  },
  domainId: CommandDomainType.Land,
};

export const INDIRECT_FIRE: TCommandConstant = {
  id: 108,
  backendId: 8,
  label: {
    tr: 'Görmeyerek Ateş',
    en: 'Indirect Fire',
    ar: 'إطلاق غير مباشر',
    es: 'Indirect Fire',
    it: 'Indirect Fire',
    ro: 'Indirect Fire',
  },
  domainId: CommandDomainType.Land,
};

export const LAY_OBSTACLE: TCommandConstant = {
  id: 112,
  backendId: 37,
  label: {
    tr: 'Engel Koyma',
    en: 'Lay Obstacle',
    ar: 'وضع عقبة',
    es: 'Lay Obstacle',
    it: 'Lay Obstacle',
    ro: 'Lay Obstacle',
  },
  domainId: CommandDomainType.Land,
};

export const CLEAR_OBSTACLE: TCommandConstant = {
  id: 113,
  backendId: 38,
  label: {
    tr: 'Engel Kaldırma',
    en: 'Clear Obstacle',
    ar: 'إزالة العقبة',
    es: 'Clear Obstacle',
    it: 'Clear Obstacle',
    ro: 'Clear Obstacle',
  },
  domainId: CommandDomainType.Land,
};

export const LAND_ENGAGEMENT: TCommandConstant = {
  id: 109,
  backendId: 16,
  label: {
    tr: 'Angajman',
    en: 'Engagement',
    ar: 'الانخراط',
    es: 'Engagement',
    it: 'Engagement',
    ro: 'Engagement',
  },
  domainId: CommandDomainType.Land,
};
export const LAND_BULK_ENGAGEMENT: TCommandConstant = {
  id: 139,
  backendId: 71,
  label: {
    tr: 'Toplu Angajman',
    en: 'Bulk Engagement',
    ar: 'الانخراط الجماعي',
    es: 'Engagement',
    it: 'Engagement',
    ro: 'Engagement',
  },
  domainId: CommandDomainType.Land,
  isBulk: true,
};

export const LAND_STOP: TCommandConstant = {
  id: 125,
  backendId: 25,
  label: {
    tr: 'Durdur',
    en: 'Stop',
    ar: 'إيقاف',
    es: 'Stop',
    it: 'Stop',
    ro: 'Stop',
  },
  domainId: CommandDomainType.Land,
};

export const LAND_CONTINUE: TCommandConstant = {
  id: 126,
  backendId: 26,
  label: {
    tr: 'Devam Et',
    en: 'Continue',
    ar: 'استمر',
    es: 'Continue',
    it: 'Continue',
    ro: 'Continue',
  },
  domainId: CommandDomainType.Land,
};

export const FIRE_SSM: TCommandConstant = {
  id: 129,
  backendId: 32,
  label: {
    tr: 'SSM Ateşle',
    en: 'Fire SSM',
    ar: 'إطلاق SSM',
    es: 'Fire SSM',
    it: 'Fire SSM',
    ro: 'Fire SSM',
  },
  domainId: CommandDomainType.Land,
};

export const LAND_CREATE_MARITIME_MISSION: TCommandConstant = {
  id: 324,
  backendId: 44,
  label: {
    tr: 'Deniz Görevi Oluştur',
    en: 'Create Maritime Mission',
    ar: 'إنشاء مهمة بحرية',
    es: 'Create Maritime Mission',
    it: 'Create Maritime Mission',
    ro: 'Create Maritime Mission',
  },
  domainId: CommandDomainType.Land,
};

export const LAND_CREATE_AIR_MISSION: TCommandConstant = {
  id: 201,
  backendId: 13,
  label: {
    tr: 'Hava Görevi Oluştur',
    en: 'Create Air Mission',
    ar: 'إنشاء مهمة جوية',
    es: 'Create Air Mission',
    it: 'Create Air Mission',
    ro: 'Create Air Mission',
  },
  domainId: CommandDomainType.Land,
};

export const FIRE_NAVIGATION_MISSILE: TCommandConstant = {
  id: 130,
  backendId: 47,
  label: {
    tr: 'Seyrüsefer Füzesini Ateşle',
    en: 'Fire Navigation Missile',
    ar: 'إطلاق صواريخ الملاحة',
    es: 'Fire Navigation Missile',
    it: 'Fire Navigation Missile',
    ro: 'Fire Navigation Missile',
  },
  domainId: CommandDomainType.Land,
};

export const BUILD_INFRASTRUCTURE: TCommandConstant = {
  id: 131,
  backendId: 54,
  label: {
    tr: 'Altyapı İnşası',
    en: 'Build Infrastructure',
    ar: 'بناء البنية التحتية',
    es: 'Build Infrastructure',
    it: 'Build Infrastructure',
    ro: 'Build Infrastructure',
  },
  domainId: CommandDomainType.Land,
};
export const RELEASE: TCommandConstant = {
  id: 121,
  backendId: 59,
  label: {
    tr: 'Serbest Bırak',
    en: 'Release',
    ar: 'إطلاق سراح',
    es: 'Release',
    it: 'Release',
    ro: 'Release',
  },
  domainId: CommandDomainType.Land,
};
export const LAND_HANDOVER_POW: TCommandConstant = {
  id: 122,
  backendId: 58,
  label: {
    tr: 'Esir Devret',
    en: 'Handover POW',
    ar: 'تسليم الأسرى',
    es: 'Handover POW',
    it: 'Handover POW',
    ro: 'Handover POW',
  },
  domainId: CommandDomainType.Land,
};

export const CAPTURE_POW: TCommandConstant = {
  id: 120,
  backendId: 57,
  label: {
    tr: 'Esir Al',
    en: 'Capture POW',
    ar: 'أسر الأسرى',
    es: 'Capture POW',
    it: 'Capture POW',
    ro: 'Capture POW',
  },
  domainId: CommandDomainType.Land,
};

export const SURRENDER: TCommandConstant = {
  id: 127,
  backendId: 56,
  label: {
    tr: 'Teslim Ol',
    en: 'Surrender',
    ar: 'استسلام',
    es: 'Surrender',
    it: 'Surrender',
    ro: 'Surrender',
  },
  domainId: CommandDomainType.Land,
};

export const BULK_SURRENDER: TCommandConstant = {
  id: 141,
  backendId: 73,
  label: {
    tr: 'Toplu Teslim Ol',
    en: 'Bulk Surrender',
    ar: 'استسلام جماعي',
    es: 'Bulk Surrender',
    it: 'Bulk Surrender',
    ro: 'Bulk Surrender',
  },
  domainId: CommandDomainType.Land,
  isBulk: true,
};

export const LAND_SET_MOVE_SPEED: TCommandConstant = {
  id: 132,
  backendId: 60,
  label: {
    tr: 'Gorev Hizini Ayarla',
    en: 'Set Move Speed',
    ar: 'تغيير سرعة الحركة',
    es: 'Set Move Speed',
    it: 'Set Move Speed',
    ro: 'Set Move Speed',
  },
  domainId: CommandDomainType.Land,
};

export const LAND_BULK_SET_MOVE_SPEED: TCommandConstant = {
  id: 140,
  backendId: 74,
  label: {
    tr: 'Toplu Gorev Hizini Ayarla',
    en: 'Bulk Set Move Speed',
    ar: 'تغيير سرعة الحركة الجماعية',
    es: 'Bulk Set Move Speed',
    it: 'Bulk Set Move Speed',
    ro: 'Bulk Set Move Speed',
  },
  domainId: CommandDomainType.Land,
  isBulk: true,
};

export const LAND_JAM: TCommandConstant = {
  id: 118,
  backendId: 63,
  label: {
    tr: 'Karistirici',
    en: 'Jam',
    ar: 'تشويش',
    es: 'Jam',
    it: 'Jam',
    ro: 'Jam',
  },
  domainId: CommandDomainType.Land,
};

export const LAND_AMBUSH: TCommandConstant = {
  id: 133,
  backendId: 65,
  label: {
    tr: 'Pusu',
    en: 'Ambush',
    ar: 'كمين',
    es: 'Ambush',
    it: 'Ambush',
    ro: 'Ambush',
  },
  domainId: CommandDomainType.Land,
};
export const LAND_BULK_AMBUSH: TCommandConstant = {
  id: 135,
  backendId: 75,
  label: {
    tr: 'Toplu Pusu',
    en: 'Bulk Ambush',
    ar: 'كمين جماعي',
    es: 'Bulk Ambush',
    it: 'Bulk Ambush',
    ro: 'Bulk Ambush',
  },
  domainId: CommandDomainType.Land,
  isBulk: true,
};

export const LAND_RAID: TCommandConstant = {
  id: 134,
  backendId: 66,
  label: {
    tr: 'Baskin',
    en: 'Raid',
    ar: 'غارة',
    es: 'Raid',
    it: 'Raid',
    ro: 'Raid',
  },
  domainId: CommandDomainType.Land,
};

export const LAND_BULK_RAID: TCommandConstant = {
  id: 143,
  backendId: 76,
  label: {
    tr: 'Toplu Baskin',
    en: 'Bulk Raid',
    ar: 'غارة جماعية',
    es: 'Bulk Raid',
    it: 'Bulk Raid',
    ro: 'Bulk Raid',
  },
  domainId: CommandDomainType.Land,
  isBulk: true,
};

export const LAND_CLEAR_BUILDING: TCommandConstant = {
  id: 144,
  backendId: 81,
  label: {
    tr: 'Bina Temizle',
    en: 'Clear Building',
    ar: 'إزالة العقبة',
    es: 'Clear Building',
    it: 'Clear Building',
    ro: 'Clear Building',
  },
  domainId: CommandDomainType.Land,
};

export const CBRN_DECONTAMINATION: TCommandConstant = {
  id: 116,
  backendId: 82,
  label: {
    tr: 'KBRN Dekontaminasyon',
    en: 'CBRN Decontamination',
    ar: 'إزالة التلوث CBRN',
    es: 'CBRN Decontamination',
    it: 'CBRN Decontamination',
    ro: 'CBRN Decontamination',
  },
  domainId: CommandDomainType.Land,
};

export const LAND_REMOVE_FROM_MANIFEST: TCommandConstant = {
  id: 145,
  backendId: 83,
  label: {
    tr: 'Manifestodan Çıkar',
    en: 'Remove From Manifest',
    ar: 'إزالة من البيان',
    es: 'Remove From Manifest',
    it: 'Remove From Manifest',
    ro: 'Remove From Manifest',
  },
  domainId: CommandDomainType.Land,
};

export const LAND_EMBARKMENT: TCommandConstant = {
  id: 146,
  backendId: 86,
  label: {
    tr: 'Kara Bindirme',
    en: 'Land Embarkment',
    ar: 'تحميل الأرض',
    es: 'Land Embarkment',
    it: 'Land Embarkment',
    ro: 'Land Embarkment',
  },
  domainId: CommandDomainType.Land,
};
export const LAND_DISEMBARKMENT: TCommandConstant = {
  id: 147,
  backendId: 87,
  label: {
    tr: 'Kara İndirme',
    en: 'Land Disembarkment',
    ar: 'إنزال الأرض',
    es: 'Land Disembarkment',
    it: 'Land Disembarkment',
    ro: 'Land Disembarkment',
  },
  domainId: CommandDomainType.Land,
};

export const SEARCH_AND_RESCUE: TCommandConstant = {
  id: 148,
  backendId: 202,
  label: {
    tr: 'Arama Kurtarma',
    en: 'Search and Rescue',
    ar: 'البحث والإنقاذ',
    es: 'Search and Rescue',
    it: 'Search and Rescue',
    ro: 'Search and Rescue',
  },
  domainId: CommandDomainType.Land,
};

export const RECOVER_EVACUATION: TCommandConstant = {
  id: 149,
  backendId: 84,
  label: {
    tr: 'Kurtarma',
    en: 'Recover',
    ar: 'استرداد',
    es: 'Recover',
    it: 'Recover',
    ro: 'Recover',
  },
  domainId: CommandDomainType.Land,
};

export const MEDICAL_EVACUATION: TCommandConstant = {
  id: 150,
  backendId: 85,
  label: {
    tr: 'Karadan Sihhiye Tahliye',
    en: 'Medical Evacuation',
    ar: 'الإخلاء الطبي',
    es: 'Medical Evacuation',
    it: 'Medical Evacuation',
    ro: 'Medical Evacuation',
  },
  domainId: CommandDomainType.Land,
};

// #endregion

// #region Air Missions
export const AIR_MISSION: TCommandConstant = {
  id: 201,
  backendId: 13,
  label: {
    tr: 'Hava Görevi Oluştur',
    en: 'Create Air Mission',
    ar: 'إنشاء مهمة جوية',
    es: 'Create Air Mission',
    it: 'Create Air Mission',
    ro: 'Create Air Mission',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_RECONNAISANCE: TCommandConstant = {
  id: 203,
  backendId: 157,
  label: {
    tr: 'Hava Keşif',
    en: 'Air Reconnaisance',
    ar: 'استطلاع جوي',
    es: 'Air Reconnaissance',
    it: 'Air Reconnaissance',
    ro: 'Air Reconnaissance',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_LIFT: TCommandConstant = {
  id: 204,
  backendId: 156,
  label: {
    tr: 'Hava Taşıma',
    en: 'Air Lift',
    ar: 'رفع جوي',
    es: 'Air Lift',
    it: 'Air Lift',
    ro: 'Air Lift',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_CAP: TCommandConstant = {
  id: 205,
  backendId: 159,
  label: {
    tr: 'Hava CAP',
    en: 'Air CAP',
    ar: 'غطاء جوي',
    es: 'Air CAP',
    it: 'Air CAP',
    ro: 'Air CAP',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_INTERCEPT: TCommandConstant = {
  id: 206,
  backendId: 160,
  label: {
    tr: 'Hava Önleme',
    en: 'Air Intercept',
    ar: 'اعتراض جوي',
    es: 'Air Intercept',
    it: 'Air Intercept',
    ro: 'Air Intercept',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_ESCORT: TCommandConstant = {
  id: 207,
  backendId: 161,
  label: {
    tr: 'Hava Himaye',
    en: 'Air Escort',
    ar: 'مرافقة جوية',
    es: 'Air Escort',
    it: 'Air Escort',
    ro: 'Air Escort',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_SEAD: TCommandConstant = {
  id: 208,
  backendId: 162,
  label: {
    tr: 'Hava SEAD',
    en: 'Air SEAD',
    ar: 'حرب SEAD',
    es: 'Air SEAD',
    it: 'Air SEAD',
    ro: 'Air SEAD',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_GROUND_ATTACK: TCommandConstant = {
  id: 209,
  backendId: 153,
  label: {
    tr: 'Hava Groumd Attack',
    en: 'Air Ground Attack',
    ar: 'هجوم جوي على الأرض',
    es: 'Air Ground Attack',
    it: 'Air Ground Attack',
    ro: 'Air Ground Attack',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_REFUEL_GIVER: TCommandConstant = {
  id: 210,
  backendId: 151,
  label: {
    tr: 'Hava İkmal Verme',
    en: 'Air Refuel Giver',
    ar: 'مقدم إمداد جوي',
    es: 'Air Refuel Giver',
    it: 'Air Refuel Giver',
    ro: 'Air Refuel Giver',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_REFUEL_TAKER: TCommandConstant = {
  id: 210,
  backendId: 152,
  label: {
    tr: 'Hava İkmal Alma',
    en: 'Air Refuel Taker',
    ar: 'مستلم إمداد جوي',
    es: 'Air Refuel Taker',
    it: 'Air Refuel Taker',
    ro: 'Air Refuel Taker',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_EWACS: TCommandConstant = {
  id: 211,
  backendId: 163,
  label: {
    tr: 'Erken İhbar & Komuta Kontrol',
    en: 'Early Warning & C2',
    ar: 'الإنذار المبكر و C2',
    es: 'Early Warning & C2',
    it: 'Early Warning & C2',
    ro: 'Early Warning & C2',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_SNR: TCommandConstant = {
  id: 212,
  backendId: 164,
  label: {
    tr: 'Arama & Kurtarma',
    en: 'Search & Rescue',
    ar: 'البحث والإنقاذ',
    es: 'Search & Rescue',
    it: 'Search & Rescue',
    ro: 'Search & Rescue',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_ENGAGEMENT_RULE: TCommandConstant = {
  id: 214,
  backendId: 16,
  label: {
    tr: 'Hava Angajman Kuralı',
    en: 'Air Engagement Rule',
    ar: 'قاعدة الاشتباك الجوي',
    es: 'Air Engagement Rule',
    it: 'Air Engagement Rule',
    ro: 'Air Engagement Rule',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_BULK_ENGAGEMENT_RULE: TCommandConstant = {
  id: 223,
  backendId: 71,
  label: {
    tr: 'Toplu Hava Angajman Kuralı',
    en: 'Bulk Air Engagement Rule',
    ar: 'قاعدة الاشتباك الجوي الجماعي',
    es: 'Bulk Air Engagement Rule',
    it: 'Bulk Air Engagement Rule',
    ro: 'Bulk Air Engagement Rule',
  },
  domainId: CommandDomainType.Air,
  isBulk: true,
};

export const AIR_MOVE: TCommandConstant = {
  id: 220,
  backendId: 150,
  label: {
    tr: 'Hava İntikal',
    en: 'Air Move',
    ar: 'حركة جوية',
    es: 'Air Move',
    it: 'Air Move',
    ro: 'Air Move',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_MERGE: TCommandConstant = {
  id: 221,
  backendId: 167,
  label: {
    tr: 'Birleş',
    en: 'Merge',
    ar: 'دمج',
    es: 'Merge',
    it: 'Merge',
    ro: 'Merge',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_DIVIDE: TCommandConstant = {
  id: 222,
  backendId: 166,
  label: {
    tr: 'Bölün',
    en: 'Divide',
    ar: 'تقسيم',
    es: 'Divide',
    it: 'Divide',
    ro: 'Divide',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_JAM: TCommandConstant = {
  id: 216,
  backendId: 63,
  label: {
    tr: 'Karistirici',
    en: 'Jam',
    ar: 'تشويش',
    es: 'Jam',
    it: 'Jam',
    ro: 'Jam',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_CAS_CCA_TASMO: TCommandConstant = {
  id: 202,
  backendId: 300,
  label: {
    tr: 'CAS/CCA/TASMO',
    en: 'CAS/CCA/TASMO',
    ar: 'CAS/CCA/TASMO',
    es: 'CAS/CCA/TASMO',
    it: 'CAS/CCA/TASMO',
    ro: 'CAS/CCA/TASMO',
  },
  domainId: CommandDomainType.Air,
};

export const AIR_REMOVE_FROM_MANIFEST: TCommandConstant = {
  id: 224,
  backendId: 83,
  label: {
    tr: 'Manifestodan Çıkar',
    en: 'Remove From Manifest',
    ar: 'إزالة من البيان',
    es: 'Remove From Manifest',
    it: 'Remove From Manifest',
    ro: 'Remove From Manifest',
  },
  domainId: CommandDomainType.Air,
};

export const MAGIC_CRASH: TCommandConstant = {
  id: 225,
  backendId: 139,
  label: {
    tr: 'Etmeni Sil',
    en: 'Magic Crash',
    ar: 'تحطم سحري',
    es: 'Magic Crash',
    it: 'Magic Crash',
    ro: 'Magic Crash',
  },
  domainId: CommandDomainType.Air,
};

export const CHANGE_LANDING_OPTIONS: TCommandConstant = {
  id: 226,
  backendId: 140,
  label: {
    tr: 'İniş Bilgileri Değiştir',
    en: 'Change Landing Options',
    ar: 'تغيير خيارات الهبوط',
    es: 'Change Landing Options',
    it: 'Change Landing Options',
    ro: 'Change Landing Options',
  },
  domainId: CommandDomainType.Air,
};

// #endregion

// #region Maritime Commands
export const FORMATION: TCommandConstant = {
  id: 301,
  backendId: 19,
  label: {
    tr: 'Formasyon',
    en: 'Formation',
    ar: 'تشكيل',
    es: 'Formation',
    it: 'Formation',
    ro: 'Formation',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_MOVE: TCommandConstant = {
  id: 302,
  backendId: 2,
  label: {
    tr: 'Denizde İntikal',
    en: 'Maritime Move',
    ar: 'تحرك بحري',
    es: 'Maritime Move',
    it: 'Maritime Move',
    ro: 'Maritime Move',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_BULK_MOVE: TCommandConstant = {
  id: 338,
  backendId: 68,
  label: {
    tr: 'Toplu Denizde İntikal',
    en: 'Bulk Maritime Move',
    ar: 'تحرك بحري جماعي',
    es: 'Bulk Maritime Move',
    it: 'Bulk Maritime Move',
    ro: 'Bulk Maritime Move',
  },
  domainId: CommandDomainType.Maritime,
  isBulk: true,
};

export const MARITIME_MISSION: TCommandConstant = {
  id: 324,
  backendId: 44,
  label: {
    tr: 'Deniz Etmeni',
    en: 'Create Maritime Mission',
    ar: 'إنشاء مهمة بحرية',
    es: 'Create Maritime Mission',
    it: 'Create Maritime Mission',
    ro: 'Create Maritime Mission',
  },
  domainId: CommandDomainType.Maritime,
};

export const TORPEDO: TCommandConstant = {
  id: 304,
  backendId: 31,
  label: {
    tr: 'Torpido',
    en: 'Torpedo',
    ar: 'طوربيد',
    es: 'Torpedo',
    it: 'Torpedo',
    ro: 'Torpedo',
  },
  domainId: CommandDomainType.Maritime,
};

export const LAY_SEA_MINES: TCommandConstant = {
  id: 307,
  backendId: 21,
  label: {
    tr: 'Deniz Mayını Döşeme',
    en: 'Lay Sea Mines',
    ar: 'زرع الألغام البحرية',
    es: 'Lay Sea Mines',
    it: 'Lay Sea Mines',
    ro: 'Lay Sea Mines',
  },
  domainId: CommandDomainType.Maritime,
};

export const SWEEP_SEA_MINES: TCommandConstant = {
  id: 308,
  backendId: 22,
  label: {
    tr: 'Deniz Mayını Temizleme',
    en: 'Sweep Sea Mines',
    ar: 'إزالة الألغام البحرية',
    es: 'Sweep Sea Mines',
    it: 'Sweep Sea Mines',
    ro: 'Sweep Sea Mines',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_TOWING: TCommandConstant = {
  id: 311,
  backendId: 53,
  label: {
    tr: 'Deniz Cekme',
    en: 'Maritime Towing',
    ar: 'سحب بحري',
    ro: 'Maritime Towing',
    es: 'Maritime Towing',
    it: 'Maritime Towing',
  },
  domainId: CommandDomainType.Maritime,
};

export const NAVAL_FIRE_SUPPORT: TCommandConstant = {
  id: 309,
  backendId: 23,
  label: {
    tr: 'Torpido',
    en: 'Naval Fire Suppoer',
    ar: 'دعم ناري بحري',
    es: 'Naval Fire Suppoer',
    it: 'Naval Fire Suppoer',
    ro: 'Naval Fire Suppoer',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_ENGAGEMENT_RULE: TCommandConstant = {
  id: 310,
  backendId: 16,
  label: {
    tr: 'Deniz Angajman Kuralı',
    en: 'Maritime Engagement Rule',
    ar: 'قاعدة الاشتباك البحري',
    es: 'Maritime Engagement Rule',
    it: 'Maritime Engagement Rule',
    ro: 'Maritime Engagement Rule',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_BULK_ENGAGEMENT_RULE: TCommandConstant = {
  id: 339,
  backendId: 71,
  label: {
    tr: 'Toplu Deniz Angajman Kuralı',
    en: 'Bulk Maritime Engagement Rule',
    ar: 'قاعدة الاشتباك البحري الجماعي',
    es: 'Bulk Maritime Engagement Rule',
    it: 'Bulk Maritime Engagement Rule',
    ro: 'Bulk Maritime Engagement Rule',
  },
  domainId: CommandDomainType.Maritime,
  isBulk: true,
};

export const MARITIME_STOP: TCommandConstant = {
  id: 315,
  backendId: 25,
  label: {
    tr: 'Durdur',
    en: 'Stop',
    ar: 'إيقاف',
    es: 'Stop',
    it: 'Stop',
    ro: 'Stop',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_CONTINUE: TCommandConstant = {
  id: 316,
  backendId: 26,
  label: {
    tr: 'Devam Et',
    en: 'Continue',
    ar: 'استمر',
    es: 'Continue',
    it: 'Continue',
    ro: 'Continue',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_LIFT: TCommandConstant = {
  id: 319,
  backendId: 33,
  label: {
    tr: 'Denizde Taşıma',
    en: 'Maritime Lift',
    ar: 'رفع بحري',
    es: 'Lift',
    it: 'Lift',
    ro: 'Lift',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_EMBARKATION: TCommandConstant = {
  id: 320,
  backendId: 35,
  label: {
    tr: 'Denizde Bindirme',
    en: 'Maritime Embarkation',
    ar: 'تحميل بحري',
    es: 'Maritime Embarkation',
    it: 'Maritime Embarkation',
    ro: 'Maritime Embarkation',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_DISEMBARKATION: TCommandConstant = {
  id: 321,
  backendId: 36,
  label: {
    tr: 'Denizde İndirme',
    en: 'Maritime Disembarkation',
    ar: 'إنزال بحري',
    es: 'Maritime Disembarkation',
    it: 'Maritime Disembarkation',
    ro: 'Maritime Disembarkation',
  },
  domainId: CommandDomainType.Maritime,
};

export const LEAVE_DISBAND_FORMATION: TCommandConstant = {
  id: 322,
  backendId: 20,
  label: {
    tr: 'Formasyondan Ayrıl/Sil',
    en: 'Leave/Disband Formation',
    ar: 'مغادرة/حل التشكيل',
    es: 'Leave/Disband Formation',
    it: 'Leave/Disband Formation',
    ro: 'Leave/Disband Formation',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_TELEPORT: TCommandConstant = {
  id: 323,
  backendId: 15,
  label: {
    tr: 'Teleport',
    en: 'Teleport',
    ar: 'نقل',
    es: 'Teleport',
    it: 'Teleport',
    ro: 'Teleport',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_PATROL: TCommandConstant = {
  id: 325,
  backendId: 45,
  label: {
    tr: 'Deniz Devriyesi',
    en: 'Maritime Patrol',
    ar: 'دورية بحرية',
    es: 'Maritime Patrol',
    it: 'Maritime Patrol',
    ro: 'Maritime Patrol',
  },
  domainId: CommandDomainType.Maritime,
};

export const DEPTH_CHARGE: TCommandConstant = {
  id: 326,
  backendId: 46,
  label: {
    tr: 'Derin Su Bombası',
    en: 'Depth Charge',
    ar: 'قنبلة عمق',
    es: 'Depth Charge',
    it: 'Depth Charge',
    ro: 'Depth Charge',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_AIR_DEFENSE: TCommandConstant = {
  id: 334,
  backendId: 30,
  label: {
    tr: 'Hava Savunması',
    en: 'Air Defense',
    ar: 'الدفاع الجوي',
    es: 'Air Defense',
    it: 'Air Defense',
    ro: 'Air Defense',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_DOCK: TCommandConstant = {
  id: 327,
  backendId: 49,
  label: {
    tr: 'Deniz Rıhtımı',
    en: 'Maritime Dock',
    ar: 'رصيف بحري',
    es: 'Maritime Dock',
    it: 'Maritime Dock',
    ro: 'Maritime Dock',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_UNDOCK: TCommandConstant = {
  id: 328,
  backendId: 50,
  label: {
    tr: 'Deniz Rıhtımdan Çıkar',
    en: 'Maritime Undock',
    ar: 'إزالة الرصيف البحري',
    es: 'Maritime Undock',
    it: 'Maritime Undock',
    ro: 'Maritime Undock',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_SUPPLY: TCommandConstant = {
  id: 329,
  backendId: 52,
  label: {
    tr: 'Deniz İkmal',
    en: 'Maritime SUPPLY',
    ar: 'الإمداد البحري',
    es: 'Maritime SUPPLY',
    it: 'Maritime SUPPLY',
    ro: 'Maritime SUPPLY',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_BOARDING: TCommandConstant = {
  id: 330,
  backendId: 48,
  label: {
    tr: 'Deniz Çıkma',
    en: 'Maritime Boarding',
    ar: 'مغادرة بحرية',
    es: 'Maritime Boarding',
    it: 'Maritime Boarding',
    ro: 'Maritime Boarding',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_FIRE_SSM: TCommandConstant = {
  id: 331,
  backendId: 32,
  label: {
    tr: 'MARITIME_FIRE_SSM',
    en: 'MARITIMIE_FIRE_SSM',
    ar: 'إطلاق SSM بحري',
    es: 'MARITIMIE_FIRE_SSM',
    it: 'MARITIMIE_FIRE_SSM',
    ro: 'MARITIMIE_FIRE_SSM',
  },
  domainId: CommandDomainType.Maritime,
};

export const FUEL_LEAKING: TCommandConstant = {
  id: 332,
  backendId: 55,
  label: {
    tr: 'Yakit Sizdirma',
    en: 'FUEL_LEAKING',
    ar: 'تسرب الوقود',
    es: 'FUEL_LEAKING',
    it: 'FUEL_LEAKING',
    ro: 'FUEL_LEAKING',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_BULK_SURRENDER: TCommandConstant = {
  id: 341,
  backendId: 73,
  label: {
    tr: 'Toplu Teslim Ol',
    en: 'Bulk Surrender',
    ar: 'استسلام جماعي',
    es: 'Bulk Surrender',
    it: 'Bulk Surrender',
    ro: 'Bulk Surrender',
  },
  domainId: CommandDomainType.Maritime,
  isBulk: true,
};

export const MARITIME_SURRENDER: TCommandConstant = {
  id: 333,
  backendId: 56,
  label: {
    tr: 'Teslim Ol',
    en: 'Surrender',
    ar: 'استسلام',
    es: 'Surrender',
    it: 'Surrender',
    ro: 'Surrender',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_SET_MOVE_SPEED: TCommandConstant = {
  id: 335,
  backendId: 60,
  label: {
    tr: 'Görev Hızını Ayarla',
    en: 'Set Move Speed',
    ar: 'تغيير سرعة الحركة',
    es: 'Set Move Speed',
    it: 'Set Move Speed',
    ro: 'Set Move Speed',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_BULK_SET_MOVE_SPEED: TCommandConstant = {
  id: 340,
  backendId: 74,
  label: {
    tr: 'Toplu görev Hızını Ayarla',
    en: 'Bulk Set Move Speed',
    ar: 'تغيير سرعة الحركة الجماعية',
    es: 'Set Move Speed',
    it: 'Set Move Speed',
    ro: 'Set Move Speed',
  },
  domainId: CommandDomainType.Maritime,
  isBulk: true,
};

export const MARITIME_HANDOVER_POW: TCommandConstant = {
  id: 336,
  backendId: 61,
  label: {
    tr: 'Esir Devret',
    en: 'Handover POW',
    ar: 'تسليم POW',
    es: 'Handover POW',
    it: 'Handover POW',
    ro: 'Handover POW',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_JAM: TCommandConstant = {
  id: 337,
  backendId: 63,
  label: {
    tr: 'Karıştırıcı',
    en: 'Jam',
    ar: 'تشويش',
    es: 'Jam',
    it: 'Jam',
    ro: 'Jam',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_DIVIDE: TCommandConstant = {
  id: 342,
  backendId: 11,
  label: {
    tr: 'Böl',
    en: 'Divide',
    ar: 'قسم',
    es: 'Divide',
    it: 'Divide',
    ro: 'Divide',
  },
  domainId: CommandDomainType.Maritime,
};

export const MARITIME_MERGE: TCommandConstant = {
  id: 343,
  backendId: 12,
  label: {
    tr: 'Birleş',
    en: 'Merge',
    ar: 'دمج',
    es: 'Divide',
    it: 'Divide',
    ro: 'Divide',
  },
  domainId: CommandDomainType.Maritime,
};

export const MAGIC_SINK: TCommandConstant = {
  id: 344,
  backendId: 139,
  label: {
    tr: 'Limitsiz Etmeni Batir',
    en: 'Magic Sink',
    ar: 'غمر سحري',
    es: 'Magic Sink',
    it: 'Magic Sink',
    ro: 'Magic Sink',
  },
  domainId: CommandDomainType.Maritime,
};

// #endregion

// #region Generic Commands
export const MAGIC_SUPPLY: TCommandConstant = {
  id: 601,
  backendId: 27,
  label: {
    tr: 'Limitsiz İkmal',
    en: 'Magic Supply',
    ar: 'إمداد سحري',
    es: 'Magic Supply',
    it: 'Magic Supply',
    ro: 'Magic Supply',
  },
  domainId: CommandDomainType.Common,
};

export const MAGIC_BULK_SUPPLY: TCommandConstant = {
  id: 611,
  backendId: 77,
  label: {
    tr: 'Limitsiz İkmal',
    en: 'Magic Supply',
    ar: 'إمداد سحري',
    es: 'Magic Supply',
    it: 'Magic Supply',
    ro: 'Magic Supply',
  },
  domainId: CommandDomainType.Common,
  isBulk: true,
};

export const UNMAGIC_SUPPLY: TCommandConstant = {
  id: 602,
  backendId: 27,
  label: {
    tr: 'Limitli İkmal',
    en: 'Unmagic Supply',
    ar: 'إمداد محدود',
    es: 'Unmagic Supply',
    it: 'Unmagic Supply',
    ro: 'Unmagic Supply',
  },
  domainId: CommandDomainType.Common,
};

export const CBRN_ATTACK: TCommandConstant = {
  id: 603,
  backendId: 39,
  label: {
    tr: 'KBRN Saldırısı',
    en: 'CBRN Attack',
    ar: 'هجوم كيميائي حيوي',
    es: 'CBRN Attack',
    it: 'CBRN Attack',
    ro: 'CBRN Attack',
  },
  domainId: CommandDomainType.Common,
};

export const CHANGE_CURRENT: TCommandConstant = {
  id: 608,
  backendId: 62,
  label: {
    tr: 'Unsur/İkmal Durumlarını Güncelle',
    en: 'Update Entity/Supply Status',
    ar: 'تحديث حالة العنصر/الإمداد',
    es: 'Update Entity/Supply Status',
    it: 'Update Entity/Supply Status',
    ro: 'Update Entity/Supply Status',
  },
  domainId: CommandDomainType.Common,
};

export const BULK_UNMAGIC_SUPPLY: TCommandConstant = {
  id: 613,
  backendId: 78,
  label: {
    tr: 'Toplu Limitli İkmal',
    en: 'Bulk Unmagic Supply',
    ar: 'إمداد محدود جماعي',
    es: 'Bulk Unmagic Supply',
    it: 'Bulk Unmagic Supply',
    ro: 'Bulk Unmagic Supply',
  },
  domainId: CommandDomainType.Common,
  isBulk: true,
};

export const CHANGE_HIGHER_AGENT: TCommandConstant = {
  id: 614,
  backendId: 10,
  label: {
    tr: 'Üst/İkmalden Sorumlu Etmen Değiştir',
    en: 'Change Higher/Supplying Agent',
    ar: 'تغيير الوكيل الأعلى/المورد',
    es: 'Change Higher/Supplying Agent',
    it: 'Change Higher/Supplying Agent',
    ro: 'Change Higher/Supplying Agent',
  },
  domainId: CommandDomainType.Common,
};

// #endregion

// #region Communication Commands
export const COMMUNICATION_ADD_TO_BL: TCommandConstant = {
  id: 701,
  backendId: 38,
  label: {
    en: 'Communication Add To Blacklist',
    tr: 'Muhabere Karalisteye Ekle',
    ar: 'إضافة إلى القائمة السوداء',
    es: 'Communication Add To Blacklist',
    it: 'Communication Add To Blacklist',
    ro: 'Communication Add To Blacklist',
  },
  domainId: CommandDomainType.Common,
};

export const COMMUNICATION_REMOVE_FROM_BL: TCommandConstant = {
  id: 702,
  backendId: 37,
  label: {
    en: 'Communication Remove From Blacklist',
    tr: 'Muhabere Karalisteden Kaldır',
    ar: 'إزالة من القائمة السوداء',
    es: 'Communication Remove From Blacklist',
    it: 'Communication Remove From Blacklist',
    ro: 'Communication Remove From Blacklist',
  },
  domainId: CommandDomainType.Common,
};

export const MAGIC_ETMEN_TAMAMLA: TCommandConstant = {
  id: 604,
  backendId: 42,
  label: {
    en: 'Magic Fill Up Agent',
    tr: 'Etmen Tamamla',
    ar: 'تعبئة السحرية للوكيل',
    es: 'Magic Fill Up Agent',
    it: 'Magic Fill Up Agent',
    ro: 'Magic Fill Up Agent',
  },
  domainId: CommandDomainType.Common,
};

export const CANCEL_THE_COMMAND: TCommandConstant = {
  id: 605,
  backendId: 43,
  label: {
    en: 'Cancel The Current Command',
    tr: 'Emri İptal Et',
    ar: 'إلغاء الأمر الحالي',
    es: 'Magic Fill Up Agent',
    it: 'Magic Fill Up Agent',
    ro: 'Magic Fill Up Agent',
  },
  domainId: CommandDomainType.Common,
};

export const DELETE: TCommandConstant = {
  id: 606,
  backendId: 9,
  label: {
    tr: 'Sil',
    en: 'Delete',
    ar: 'حذف',
    es: 'Delete',
    it: 'Delete',
    ro: 'Delete',
  },
  domainId: CommandDomainType.Common,
};

export const BULK_DELETE: TCommandConstant = {
  id: 610,
  backendId: 79,
  label: {
    tr: 'Toplu Sil',
    en: 'Bulk Delete',
    ar: 'حذف جماعي',
    es: 'Bulk Delete',
    it: 'Bulk Delete',
    ro: 'Bulk Delete',
  },
  domainId: CommandDomainType.Common,
  isBulk: true,
};

export const TOGGLE_AIS: TCommandConstant = {
  id: 607,
  backendId: 134,
  label: {
    tr: 'Toggle AIS',
    en: 'Toggle AIS',
    ar: 'تبديل AIS',
    es: 'Toggle AIS',
    it: 'Toggle AIS',
    ro: 'Toggle AIS',
  },
  domainId: CommandDomainType.Common,
};

export const BULK_TOGGLE_AIS: TCommandConstant = {
  id: 612,
  backendId: 80,
  label: {
    tr: 'Bulk Toggle AIS',
    en: 'Bulk Toggle AIS',
    ar: 'تبديل AIS جماعي',
    es: 'Bulk Toggle AIS',
    it: 'Bulk Toggle AIS',
    ro: 'Bulk Toggle AIS',
  },
  domainId: CommandDomainType.Common,
  isBulk: true,
};

export const CHANGE_VOLUME: TCommandConstant = {
  id: 609,
  backendId: 67,
  label: {
    tr: 'Change Volume',
    en: 'Change Volume',
    ar: 'تغيير مستوى الصوت',
    es: 'Change Volume',
    it: 'Change Volume',
    ro: 'Change Volume',
  },
  domainId: CommandDomainType.Common,
};

export const TOGGLE_ENTITY: TCommandConstant = {
  id: 615,
  backendId: 90,
  label: {
    tr: 'Varlığı Göster/Gizle',
    en: 'Toggle Entity',
    ar: 'تبديل الكيان',
    es: 'Toggle Entity',
    it: 'Toggle Entity',
    ro: 'Toggle Entity',
  },
  domainId: CommandDomainType.Common,
};

export const BULK_TOGGLE_ENTITY: TCommandConstant = {
  id: 616,
  backendId: 91,
  label: {
    tr: 'Toplu Varlığı Göster/Gizle',
    en: 'Bulk Toggle Entity',
    ar: 'تبديل الكيانجماعي',
    es: 'Bulk Toggle Entity',
    it: 'Bulk Toggle Entity',
    ro: 'Bulk Toggle Entity',
  },
  domainId: CommandDomainType.Common,
  isBulk: true,
};

// #endregion

// #region control commands
export const CREATE_AGENT: TCommandConstant = {
  id: 9,
  backendId: 125,
  label: {
    en: 'Create Agent',
    tr: 'Etmen Oluştur',
    ar: 'إنشاء وكيل',
    es: 'Create Agent',
    it: 'Create Agent',
    ro: 'Create Agent',
  },
  domainId: CommandDomainType.Control,
};

export const SAVE_CHECKPOINT: TCommandConstant = {
  id: 13,
  backendId: 132,
  label: {
    en: 'Save Checkpoint',
    tr: 'Kontrol Noktası Kaydet',
    ar: 'حفظ نقطة التفتيش',
    es: 'Save Checkpoint',
    it: 'Save Checkpoint',
    ro: 'Save Checkpoint',
  },
  domainId: CommandDomainType.Control,
};

export const LOAD_CHECKPOINT: TCommandConstant = {
  id: 14,
  backendId: 133,
  label: {
    en: 'Load Checkpoint',
    tr: 'Kontrol Noktası Yükle',
    ar: 'تحميل نقطة التفتيش',
    es: 'Load Checkpoint',
    it: 'Load Checkpoint',
    ro: 'Load Checkpoint',
  },
  domainId: CommandDomainType.Control,
};

// #endregion

// #region LRC Command

export const LRC: TCommandConstant = {
  id: 703,
  backendId: 703,
  label: {
    en: 'LRC',
    tr: 'LRC',
    ar: 'LRC',
    es: 'LRC',
    it: 'LRC',
    ro: 'LRC',
  },
  domainId: CommandDomainType.LRC,
};

// #endregion

// #region Disaster Command

export const EARTHQUAKE: TCommandConstant = {
  id: 801,
  backendId: 200,
  label: {
    en: 'Earthquake',
    tr: 'Deprem',
    ar: 'زلزال',
    es: 'Earthquake',
    it: 'Earthquake',
    ro: 'Earthquake',
  },
  domainId: CommandDomainType.Disaster,
};

export const FLOOD: TCommandConstant = {
  id: 802,
  backendId: 201,
  label: {
    en: 'Flood',
    tr: 'Sel',
    ar: 'فيضان',
    es: 'Flood',
    it: 'Flood',
    ro: 'Flood',
  },
  domainId: CommandDomainType.Disaster,
};

// #endregion

// #region auto comao

export const AC_AIR_GROUND_ATTACK: TCommandConstant = {
  id: 901,
  backendId: 92,
  label: {
    tr: 'Auto Comao Air Ground Attack',
    en: 'Auto Comao Air Ground Attack',
    ar: 'هجوم أرضي جوي تلقائي',
    es: 'Auto Comao Air Ground Attack',
    it: 'Auto Comao Air Ground Attack',
    ro: 'Auto Comao Air Ground Attack',
  },
  domainId: CommandDomainType.Common,
};

export const AC_CAP: TCommandConstant = {
  id: 902,
  backendId: 93,
  label: {
    tr: 'Auto Comao Air CAP',
    en: 'Auto Comao Air CAP',
    ar: 'CAP جوي تلقائي',
    es: 'Auto Comao Air CAP',
    it: 'Auto Comao Air CAP',
    ro: 'Auto Comao Air CAP',
  },
  domainId: CommandDomainType.Common,
};
export const AC_AWACS: TCommandConstant = {
  id: 903,
  backendId: 94,
  label: {
    en: 'Auto Comao AWACS',
    tr: 'Auto Comao AWACS',
    ar: 'AWACS تلقائي',
    es: 'Auto Comao AWACS',
    it: 'Auto Comao AWACS',
    ro: 'Auto Comao AWACS',
  },
  domainId: CommandDomainType.Common,
};

export const AC_MARITIME_PATROL: TCommandConstant = {
  id: 904,
  backendId: 98,
  label: {
    tr: 'Auto Comao Maritime Patrol',
    en: 'Auto Comao Maritime Patrol',
    ar: 'دورية بحرية تلقائية',
    es: 'Auto Comao Maritime Patrol',
    it: 'Auto Comao Maritime Patrol',
    ro: 'Auto Comao Maritime Patrol',
  },
  domainId: CommandDomainType.Common,
};

// #endregion
